// import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
// import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
// import { Router } from '@angular/router';
// import { Observable } from 'rxjs';
// import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
// import { ApiService } from 'src/app/Services/api.service';
// import { CommonServices } from 'src/app/Services/common.service';
// import { FileUploadService } from 'src/app/Services/file-upload.service';
// import { StorageService } from 'src/app/Services/storage.service';
// import { SweetAlert } from 'src/app/Services/sweetalet.service';
// import { LoaderService } from 'src/app/Services/loader.service';

// @Component({
//   selector: 'app-create-vehicle',
//   templateUrl: './create-vehicle.component.html',
//   styleUrls: ['./create-vehicle.component.css'],
// })
// export class CreateVehicleComponent implements OnInit {

//   public breadcrumbData = {
//     "Information": "/organization/transport-manager/information",
//     "Vendors": "/organization/transport-manager/information/vendor/view-vendor",
//   };
//   matFormSize = '13px';
//   addVehicelForm: FormGroup;
//   formSubmit: boolean = false;
//   isShowSimno = false;
//   isShowVendorName = false;

//   isLocationMandatory: boolean = false;

//   public vehicleLocation = {};
//   public fieldOptions = {
//     model: [
//       { name: "Hatchback", value: "Hatchback", capacity: 3, max: 3 },
//       { name: "Sedan", value: "Sedan", capacity: 4, max: 4 },
//       { name: "SUV", value: "SUV", capacity: 7, max: 7 },
//       { name: "Van", value: "Van", capacity: 15, max: 15 },
//       { name: "Bus", value: "Bus", capacity: 60, max: 60 },
//       { name: "Auto", value: "Auto", capacity: 3, max: 3 },
//       { name: "Load Vehicle", value: "loadVehicle", capacity: 2, max: 100 }
//     ],
//   };

//   VendorInfos: any;
//   routerLinks: any;

//   // rc
//   imageData: File | undefined = undefined;
//   filePreview: string | null = null;
//   rcContentType: string | undefined = undefined;
//   @ViewChild('rcfile') rcfile: ElementRef;

//   // fc
//   fcImage: File | undefined = undefined;
//   fcPreview: string | undefined = undefined;
//   fcContentType: string | null = null;
//   @ViewChild('fcfile') fcfile: ElementRef;

//   // puc
//   pucImage: File | null = undefined;
//   pucPreview: string | null = undefined;
//   pucContentType: string | null = null;
//   @ViewChild('pucfile') pucfile: ElementRef;

//   // ins 
//   insuranceImage: File | null = null;
//   insPreview: string | null = null;
//   insContentType: string | null = null;
//   @ViewChild('insurancefile') insurancefile: ElementRef;
//   dynamicTopPositionRc: number = 60;
//   dynamicTopPositionFC: number = 60;
//   dynamicTopPositionIns: number = 60;
//   dynamicTopPositionPuc: number = 60;

//   /* Branch field */
//   public branchLists: any = [];
//   public selectedBranch = [];
//   @ViewChild('branchSearch') branchSearchTextBox: ElementRef;
//   branchSearchChangeObserver: any;
//   public enableBranchField: boolean = false;
//   public branchSearchVal: any = '';

//   /* Error object */
//   public errorObject: any = {};

//   //For status default select
//   public statusSelected: any = true.toString();
//   public vehStatus: any = '';
//   //display remarks
//   public showRemarks = false;
//   //vehicle capacity
//   public vehCapacity: any = {};
//   fuelType: any;
//   imageUrl: any;
//   minDate: Date;

//   constructor(
//     public fb: FormBuilder,
//     public api: ApiService,
//     public swal: SweetAlert,
//     public storage: StorageService,
//     public router: Router,
//     public file: FileUploadService,
//     public comService: CommonServices,
//     public loader:LoaderService
//   ) {

//     this.VendorInfos = this.storage.get('vendorID_orgID');
//     let vendorName = this.VendorInfos['vendorName'];
//     if (vendorName) {
//       vendorName = this.comService.strTruncate(vendorName, 13);
//       this.breadcrumbData[vendorName] = "/organization/transport-manager/information/vendor/single-view-vendor/" + this.VendorInfos.vendorID;
//     } else {
//       this.breadcrumbData['Vendor'] = "/organization/transport-manager/information/vendor/single-view-vendor/" + this.VendorInfos.vendorID;
//     }
//     this.breadcrumbData['Vehicles'] = "/organization/transport-manager/information/vehicle/view-vehicle/" + this.VendorInfos.vendorID;
//     this.breadcrumbData['Create'] = '';

//     this.routerLinks = `/organization/transport-manager/information/vehicle/view-vehicle/${this.VendorInfos.vendorID}`;
//   }

//   ngOnInit(): void {
//     this.getVehCapacity();
//     this.getBranchList();
//     this.addFormLoad();
//     // const today = new Date().toISOString().split('T')[0];
//     // console.log("today?",today)
//     // document.getElementById('rcExpiryDate').setAttribute('min', today);
//     // const currentDate = new Date();
//     this.minDate = new Date();
//   }

//   addFormLoad() {
//     this.addVehicelForm = new FormGroup({
//       vehRegNo: new FormControl('', [Validators.required, Validators.pattern('[A-Z|a-z]{2}[0-9]{1,2}[A-Z|a-z]{0,2}[0-9]{4}')]),
//       imei: new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(50), Validators.pattern('^[0-9|a-z|A-Z]*$')]),
//       make: new FormControl(''), /* , [Validators.required]), */
//       model: new FormControl('', [Validators.required]),
//       capacity: new FormControl('', [Validators.required, Validators.min(1), Validators.max(100)]),
//       vehicleType: new FormControl(''), /* , [Validators.required]), */
//       branch: new FormControl('', [Validators.required]),

//       chassisNo: new FormControl(''), /* [Validators.required, Validators.minLength(17)]), */
//       engineNo: new FormControl(''), /* [Validators.required, Validators.minLength(17)]), */
//       vehRegDate: new FormControl(''), /* , [Validators.required]), */
//       routePermitNo: new FormControl(''),
//       startDate: new FormControl(''), /* [Validators.required]), */
//       rcNo: new FormControl(''), /* [Validators.required]), */
//       rcfile: new FormControl(''), /* [Validators.required]), */
//       vehicleInfo: new FormControl(''), /* [Validators.required]), */
//       location: new FormControl(''), /* [Validators.required]), */
//       boxType: new FormControl('', [Validators.required]),
//       isActive: new FormControl('', [Validators.required]),
//       // remarks:new FormControl('', [Validators.required]),
//       roadTaxStatus: new FormControl(''), /* [Validators.required]), */
//       fuelType: new FormControl('', [Validators.required]),
//       rcStartDate: new FormControl('', [Validators.required]),
//       rcExpiryDate: new FormControl('', [Validators.required]),
//       pucExpiryDate: new FormControl('', [Validators.required]),
//       fcExpiryDate: new FormControl('', [Validators.required]),
//       insuranceExpiryDate: new FormControl('', [Validators.required]),
//       fcfile: new FormControl(''),/* [Validators.required]), */
//       insurancefile: new FormControl(''),/* [Validators.required]), */
//       pucfile: new FormControl(''),/* [Validators.required]), */
//     });
//     // const rcStartDate = this.addVehicelForm.get('rcStartDate').value;
//     // this.minExpiryDate = rcStartDate ? new Date(rcStartDate).toISOString().split('T')[0] : new Date().toISOString().split('T')[0];
//   }

//   _keyPress(event: any) {
//     const pattern = /[0-9]/;
//     const inputChar = String.fromCharCode(event.charCode);
//     if (!pattern.test(inputChar)) {
//       event.preventDefault();
//     }
//   }

//   getLocation(obj) {
//     // console.log(obj);
//     this.vehicleLocation = { ...obj };
//   }

//   patchVehicleCapacity(e) {
//     this.vehCapacity.filter((option) => {
//       if (option.value == e.value) {
//         this.addVehicelForm.controls['capacity'].setValidators([Validators.required, Validators.min(1), Validators.max(option.max)])
//         this.addVehicelForm.controls['capacity'].patchValue(option.capacity);
//       }
//     })
//     if (this.formSubmit) this.validation();
//   }
//   patchFuelType(e) {
//   }
//   typeChange(e) {
//   }

//   onChangeBoxType(e) {
//     // console.log(e.value);
//     this.isShowVendorName = false;
//     this.isShowSimno = false;
//     if (e.value == 'others') {
//       this.addVehicelForm.removeControl('simNo');
//       this.addVehicelForm.addControl('vendorName', new FormControl('', [Validators.required])); /* , [Validators.required])); */
//       this.isShowVendorName = true;
//     }
//     if (e.value == 'G10 Gps Device') {
//       this.addVehicelForm.removeControl('vendorName');
//       this.addVehicelForm.addControl('simNo', new FormControl('', [Validators.required, Validators.minLength(10), Validators.maxLength(13)]));
//       this.isShowSimno = true;
//     }
//     if (this.formSubmit) this.validation();
//   }
//   getVehCapacity() {
//     this.api.transportManagerVehicleCapacity({}).then((res: any) => {
//       if (res.status == 'success' && res.data.length > 0 && res.data[0].vehicleTypes.length > 0) {
//         this.vehCapacity = res.data[0].vehicleTypes;
//         this.fuelType = res.data[0].fuelType;
//       }
//     }).catch((err) => {
//       console.log(err);
//     });
//   }
//   getBranchList(name?) {
//     this.enableBranchField = false;
//     this.branchLists = [];
//     const obj = {};
//     if (name) obj['branchName'] = name;

//     this.api.transportManagerBranchList(obj).then((res: any) => {
//       if (res.status == 'success') {
//         if (res.data && res.data.length > 0) {
//           res.data.filter(item => {
//             try {
//               if (item.branchName && item.branchID) {
//                 let branchObj = {
//                   name: item.branchName,
//                   value: item.branchID,
//                 };
//                 let pushObj: boolean = true;
//                 this.selectedBranch.map((item) => { if (item.value == branchObj.value) { pushObj = false; } });
//                 if (pushObj) this.branchLists.push(branchObj);

//               }
//             } catch (err) {
//               console.log('branch', err);
//             }
//           });
//         }
//       }
//       setTimeout(() => { this.enableBranchField = true }, 200);
//     }).catch((err) => {
//       console.log(err);
//     });
//   }

//   // search
//   branchSearchChange(searchValue: string) {
//     searchValue = searchValue.trim().replace(/[^a-zA-Z0-9-_&, ]/g, '');

//     if (!this.branchSearchChangeObserver) {
//       new Observable(observer => {
//         this.branchSearchChangeObserver = observer;
//       }).pipe(debounceTime(500)) // wait 300ms after the last event before emitting last event
//         .pipe(distinctUntilChanged()) // only emit if value is different from previous value
//         .subscribe((term: any) => {
//           // your code here
//           this.getBranchList(term);
//         });
//     }

//     this.branchSearchChangeObserver.next(searchValue);
//   }

//   branchSelectionResult(value) {
//     if (!Array.isArray(value)) value = [value];
//     let result = [];
//     let removedResult = [];
//     for (let i = 0; i < value.length; i++) {
//       let val = value[i];
//       this.selectedBranch.map((item) => {
//         if (item.value == val) {
//           let valIndex = result.findIndex((e) => e.value == item.value);
//           if (valIndex == -1) result.push(item);
//         }
//       })
//       this.branchLists.map((veh) => {
//         if (veh.value == val) {
//           let valIndex = result.findIndex((e) => e.value == veh.value);
//           if (valIndex == -1) result.push(veh);
//         }
//       })
//     }
//     this.selectedBranch.map((branch) => {
//       if (!value.includes(branch.value)) {
//         let pushObj: boolean = true;
//         removedResult.map((e) => { if (e.value == branch.value) pushObj = false; });
//         if (pushObj) removedResult.unshift(branch);
//       }
//     })
//     this.enableBranchField = false;
//     this.branchLists = [...removedResult, ...this.branchLists]
//     this.enableBranchField = true;

//     this.selectedBranch = [...result];
//     if (this.branchSearchTextBox && this.branchSearchTextBox.nativeElement)
//       this.branchSearchTextBox.nativeElement.value = '';
//     this.clearDuplicates();
//   }

//   clearDuplicates() {
//     let result = [];
//     this.enableBranchField = false;
//     this.branchLists.map((branchObj) => {

//       let pushObj: boolean = true;
//       this.selectedBranch.map((item) => { if (item.value == branchObj.value) pushObj = false; });
//       if (pushObj) result.push(branchObj);

//     });
//     this.branchLists = [...result];
//     this.enableBranchField = true;
//   }

//   clearBranchSearch(event) {
//     this.branchSearchTextBox.nativeElement.value = '';
//     this.getBranchList();
//   }

//   /* private getChangedProperties(): string[] {
//     let changedProperties = [];
  
//     Object.keys(this.addVehicelForm.controls).forEach((name) => {
//       const currentControl = this.addVehicelForm.controls[name];
  
//       if (currentControl.dirty) {
//         changedProperties.push(name);
//       }
//     });
    
//     return changedProperties;
//   } */



//   async handleUpload(event: Event, type: string) {
//     const file = (event.target as HTMLInputElement).files?.[0];
//     const maxFileSizeInMB = 1;
//     const maxFileSize = maxFileSizeInMB * 1024 * 1024;
//     const allowedImageTypes = ['image/jpeg', 'image/png', 'image/gif'];
//     const allowedPdfType = 'application/pdf';

//     if (!file) return;

//     const fileType = file.type;
//     const isImageOrPdf = allowedImageTypes.includes(fileType) || fileType === allowedPdfType;

//     if (!isImageOrPdf) {
//       this.handleInvalidFileType(type);
//       return this.showErrorMessage('Invalid file type. Only images and PDFs are allowed.');
//     }

//     if (file.size > maxFileSize) {
//       this.handleFileSizeExceeded(type);
//       return this.showErrorMessage(`File size exceeds ${maxFileSizeInMB} MB`);
//     }

//     this.processFile(file, type, fileType, allowedImageTypes.includes(fileType) ? 'Image' : 'PDF');

//     if (this.formSubmit) this.validation();
//   }

//   private processFile(file: File, type: string, fileType: string, contentType: string) {
//     const fileReader = new FileReader();
//     fileReader.onload = () => this.updateFormAndPreview(type, file, fileReader.result as string, contentType);
//     fileReader.readAsDataURL(file);
//   }

//   private updateFormAndPreview(type: string, file: File, previewData: string, contentType: string) {
//     switch (type) {
//       case 'rcfile':
//         this.imageData = file;
//         this.rcContentType = contentType;
//         this.filePreview = previewData;
//         this.addVehicelForm.controls.rcfile.patchValue(file);
//         break;
//       case 'fcfile':
//         this.fcImage = file;
//         this.fcContentType = contentType;
//         this.fcPreview = previewData;
//         this.addVehicelForm.controls.fcfile.patchValue(file);
//         break;
//       case 'pucfile':
//         this.pucImage = file;
//         this.pucContentType = contentType;
//         this.pucPreview = previewData;
//         this.addVehicelForm.controls.pucfile.patchValue(file);
//         break;
//       case 'insurancefile':
//         this.insuranceImage = file;
//         this.insContentType = contentType;
//         this.insPreview = previewData;
//         this.addVehicelForm.controls.insurancefile.patchValue(file);
//         break;
//     }
//   }

//   private handleInvalidFileType(type: string) {
//     this.resetFileFields(type);
//   }

//   private handleFileSizeExceeded(type: string) {
//     this.resetFileFields(type);
//   }

//   private resetFileFields(type: string) {
//     switch (type) {
//       case 'rcfile':
//         this.imageData = null;
//         this.filePreview = null;
//         this.rcContentType = null;
//         this.addVehicelForm.controls.rcfile.reset();
//         this.clearInputField(this.rcfile);
//         break;
//       case 'fcfile':
//         this.fcImage = null;
//         this.fcPreview = null;
//         this.fcContentType = null;
//         this.addVehicelForm.controls.fcfile.reset();
//         this.clearInputField(this.fcfile);
//         break;
//       case 'pucfile':
//         this.pucImage = null;
//         this.pucPreview = null;
//         this.pucContentType = null;
//         this.addVehicelForm.controls.pucfile.reset();
//         this.clearInputField(this.pucfile);
//         break;
//       case 'insurancefile':
//         this.insuranceImage = null;
//         this.insPreview = null;
//         this.insContentType = null;
//         this.addVehicelForm.controls.insurancefile.reset();
//         this.clearInputField(this.insurancefile);
//         break;
//     }
//   }

//   private clearInputField(inputElement: ElementRef) {
//     if (inputElement) inputElement.nativeElement.value = '';
//   }

//   private showErrorMessage(message: string) {
//     this.swal.swalFunction('error', 'error', message, 5000);
//   }


//   reUpload(field: string) {
//     const fileFieldMap = {
//       'rcfile': this.rcfile,
//       'fcfile': this.fcfile,
//       'pucfile': this.pucfile,
//       'insurancefile': this.insurancefile
//     };

//     const fileInput = fileFieldMap[field];
//     if (fileInput) {
//       fileInput.nativeElement.click();
//     }
//   }

//   cancelImage(type: string) {
//     if (type == 'rcfile') {
//       this.addVehicelForm.controls.rcfile.patchValue('');
//       this.imageData = undefined;
//     } if (type == 'fcfile') {
//       this.addVehicelForm.controls.fcfile.patchValue('');
//       this.fcImage = undefined;
//     } if (type == 'pucfile') {
//       this.addVehicelForm.controls.pucfile.patchValue('');
//       this.pucImage = undefined;
//     } if (type == 'insurancefile') {
//       this.addVehicelForm.controls.insurancefile.patchValue('');
//       this.insuranceImage = undefined;
//     }
//   }

//   // check Error in form field
//   public checkError = (controlName: string, errorName: string) => {
//     return this.addVehicelForm.controls[controlName].hasError(errorName);
//   }

//   statusChange(value: any) {
//     this.vehStatus = true;
//     this.showRemarks = false;
//     if (this.vehStatus !== (value === 'true')) {
//       this.showRemarks = true;
//     }
//     if (this.showRemarks) {
//       this.addVehicelForm.addControl("remarks", new FormControl('', [Validators.required]));
//     } else {
//       this.addVehicelForm.removeControl("remarks");
//     }
//   }
//   validation() {
//     this.errorObject = {};
//     let fields = Object.keys(this.addVehicelForm.controls);
//     fields.map((field) => {
//       if (this.checkError(field, 'required')) {
//         this.errorObject[field] = field.charAt(0).toUpperCase() + field.slice(1).toLowerCase() + ' is required';
//         if (field == 'vehRegNo') this.errorObject[field] = 'Registration No is required';
//         else if (field == 'imei') this.errorObject[field] = 'IMEI is required';
//         else if (field == 'vehicleType') this.errorObject[field] = 'Vehicle Type is required';
//         else if (field == 'chassisNo') this.errorObject[field] = 'Chassis No is required';
//         else if (field == 'engineNo') this.errorObject[field] = 'Engine No is required';
//         else if (field == 'fcExpiryDate') this.errorObject[field] = 'FC expiry date  is required';
//         else if (field == 'pucExpiryDate') this.errorObject[field] = 'PUC expiry date is required';
//         else if (field == 'routePermitCost') this.errorObject[field] = 'Route Permit Cost is required';
//         else if (field == 'startDate') this.errorObject[field] = 'Start Date is required';
//         else if (field == 'insuranceExpiryDate') this.errorObject[field] = 'Insurance expiry date is required';
//         else if (field == 'rcNo') this.errorObject[field] = 'RC Book No is required';
//         else if (field == 'rcStartDate') this.errorObject[field] = 'RC Start date is required';
//         else if (field == 'rcExpiryDate') this.errorObject[field] = 'RC expiry date is required';
//         else if (field == 'vehicleInfo') this.errorObject[field] = 'Vehicle Info is required';
//         else if (field == 'boxType') this.errorObject[field] = 'Box type is required';
//         else if (field == 'isActive') this.errorObject[field] = 'Status is required';
//         else if (field == 'remarks') this.errorObject[field] = 'Remarks is required';
//         else if (field == 'vendorName') this.errorObject[field] = 'Vendor Name is required';
//         else if (field == 'simNo') this.errorObject[field] = 'SIM No is required';
//         else if (field == 'roadTaxStatus') this.errorObject[field] = 'Road Tax Paid is required';
//         else if (field == 'rcfile') this.errorObject[field] = 'RC File is required';
//         else if (field == 'fuelType') this.errorObject[field] = 'Fuel type is required';
//       }
//       else if (field == 'vehRegNo') {
//         if (this.checkError(field, 'pattern')) this.errorObject[field] = 'Registration No is Incorrect';
//       } else if (field == 'imei' || field == 'chassisNo' || field == 'engineNo' || field == 'routePermitCost') {
//         if (this.checkError(field, 'minlength')) {
//           if (field == 'imei') this.errorObject[field] = "IMEI should be above 3 characters";
//           else if (field == 'chassisNo') this.errorObject[field] = "Chassis No should be more than 17 characters";
//           else if (field == 'engineNo') this.errorObject[field] = "Engine No should be more than 17 characters";
//           else if (field == 'routePermitCost') this.errorObject[field] = "Route Permit Cost should be minimum than 4 digits";
//         } else if (this.checkError(field, 'maxlength')) {
//           if (field == 'imei') this.errorObject[field] = "IMEI should be less than 50 characters";
//           else if (field == 'routePermitCost') this.errorObject[field] = "Route Permit Cost should be more than 7 digits";
//         }
//         else if (this.checkError(field, 'pattern')) {
//           if (field == 'imei') this.errorObject[field] = "IMEI should be valid";
//         }
//       } else if (field == 'capacity') {
//         if (this.checkError(field, 'min')) this.errorObject[field] = "Minimum capacity is required";
//         else if (this.checkError(field, 'max')) this.errorObject[field] = "Maximum capacity is reached";
//       }
//       else if (field == 'rcStartDate' || field == 'rcExpiryDate' || field == 'expiryDate' || field == 'startDate') {
//         if (this.checkError(field, 'matDatepickerMin')) {
//           if (field == 'startDate') this.errorObject[field] = 'Start Date is Invalid';
//           else if (field == 'expiryDate') this.errorObject[field] = 'Expiry Date is Invalid';
//           else if (field == 'rcStartDate') this.errorObject[field] = 'RC Start Date is Invalid';
//           else if (field == 'rcExpiryDate') this.errorObject[field] = 'RC Expiry Date is Invalid';
//         }
//       }
//     })
//   }

//   onSubmit() {
//     this.formSubmit = true;
//     this.validation();
//     //console.log(this.getChangedProperties())
//     if (!this.addVehicelForm.valid) {
//       return;
//     }

//     const obj = {
//       orgID: this.storage.get('userInfo').orgID,
//       vendorID: this.VendorInfos.vendorID,
//     };
//     //obj.rcfile = this.imageData; 

//     let keys = Object.keys(this.addVehicelForm.value);
//     if (keys.length > 0) {
//       for (let k = 0; k < keys.length; k++) {
//         let key = keys[k];
//         if (this.addVehicelForm.value[key] != '' &&
//           this.addVehicelForm.value[key] != [] &&
//           this.addVehicelForm.value[key] != {}) {
//           obj[key] = this.addVehicelForm.value[key];
//         }
//       }
//     }

//     if (Object.keys(this.vehicleLocation).length > 0) obj['location'] = { ...this.vehicleLocation };
//     if (obj['roadTaxStatus']) obj['roadTaxStatus'] = obj['roadTaxStatus'] == 'true' ? true : false;
//     if (obj['vehRegNo']) obj['vehRegNo'] = obj['vehRegNo'].toUpperCase();
//     if (obj['fcExpiryDate']) obj['fcExpiryDate'] = new Date(obj['fcExpiryDate']).getTime();
//     if (obj['rcExpiryDate']) obj['rcExpiryDate'] = new Date(obj['rcExpiryDate']).getTime();
//     if (obj['insuranceExpiryDate']) obj['insuranceExpiryDate'] = new Date(obj['insuranceExpiryDate']).getTime();
//     if (obj['pucExpiryDate']) obj['pucExpiryDate'] = new Date(obj['pucExpiryDate']).getTime();
//     if (obj['rcExpiryDate']) obj['rcExpiryDate'] = new Date(obj['rcExpiryDate']).getTime();
//     if (obj['rcStartDate']) obj['rcStartDate'] = new Date(obj['rcStartDate']).getTime();
//     if (obj['simNo']) obj['simNo'] = parseInt(obj['simNo']);
//     if (obj['vendorName']) obj['vendorName'] = parseInt(obj['vendorName']);
//     if (obj['isActive']) obj['isActive'] = (obj['isActive'] === 'true');
//     if (obj['capacity']) obj['capacity'] = parseInt(obj['capacity']);

//     if (this.imageData) {
//       obj['rcFiles'] = this.imageData;
//       obj['rcContentType'] = this.rcContentType;
//     }
//     if (this.fcImage) {
//       obj['fcFiles'] = this.fcImage;
//       obj['fcContentType'] = this.fcContentType;
//     };
//     if (this.insuranceImage) {
//       obj['insFiles'] = this.insuranceImage;
//       obj['insContentType'] = this.insContentType;
//     }
//     if (this.pucImage) {
//       obj['pucFiles'] = this.pucImage;
//       obj['pucContentType'] = this.pucContentType;
//     };
//     delete obj['pucfile'];
//     delete obj['fcfile'];
//     delete obj['rcfile'];
//     delete obj['insurancefile'];



//     let url = 'organization/vehicle/createVehicle';
//     this.api.transportManagerFormDataCreate(obj, url, (res: any) => {
//       if (res['responseJSON']['status'] == 'success') {
//         this.imageData = undefined;
//         this.fcImage = undefined;
//         this.pucImage = undefined;
//         this.insuranceImage = undefined;
//         this.swal.swalFunction(res['responseJSON'].status, res['responseJSON'].status, res['responseJSON'].message, 2000);
//         this.router.navigate([this.routerLinks]);
//       }
//       if (res['responseJSON'].status == 'failure') {
//         this.loader.hide();
//         this.swal.swalFunction('error', res['responseJSON'].status, res['responseJSON'].message, 3000);
//       }
//     })
//   }
//   previewImage(imageUrl) {
//     // this.imageUrl = image;
//     if (imageUrl.startsWith('data:image')) {
//       const newWindow = window.open();
//       if (newWindow) {
//         newWindow.document.write(`<img src="${imageUrl}" style="width:100%;">`);
//         newWindow.document.title = "Image Preview";
//       }
//     } else {
//       window.open(imageUrl, '_blank');
//     }
//   }
//   openPdf(pdfUrl: string) {
//     if (pdfUrl.startsWith('data:application/pdf;base64,')) {
//       const newWindow = window.open();
//       if (newWindow) {
//         newWindow.document.write(`
//           <html>
//             <head>
//               <title>PDF Preview</title>
//             </head>
//             <body style="margin: 0; padding: 0; overflow: hidden;">
//               <embed src="${pdfUrl}" type="application/pdf" width="100%" height="100%" />
//             </body>
//           </html>
//         `);
//       }
//     } else {
//       // Handle URL-based PDF
//       window.open(pdfUrl, '_blank');
//     }
//   }
//   check() {
//     console.log(this.addVehicelForm.value.rcExpiryDate)
//   }
//   truncateFilename(filename: string | undefined): string {
//     if (!filename) return '';
//     if (filename.length <= 20) return filename;
//     return filename.substr(0, 10) + '...' + filename.substr(filename.length - 7);
//   }

//   onImageLoad(event: Event, field: string) {
//     const imgElement = event.target as HTMLImageElement;

//     const imageWidth = imgElement.naturalWidth;
//     const imageHeight = imgElement.naturalHeight;

//     if (imageWidth >= 1080 && imageHeight <= 2376) {
//       if (['dynamicTopPositionRc', 'dynamicTopPositionFC', 'dynamicTopPositionIns', 'dynamicTopPositionPuc'].includes(field)) {
//         this[field] = 140
//       }
//     }
//     else if ((imageWidth >= 400 && imageWidth <= 2532) && (imageHeight >= 1000 && imageHeight <= 2780)) {
//       if (['dynamicTopPositionRc', 'dynamicTopPositionFC', 'dynamicTopPositionIns', 'dynamicTopPositionPuc'].includes(field)) {
//         this[field] = 150;
//       }
//     }
//     else {
//       if (['dynamicTopPositionRc', 'dynamicTopPositionFC', 'dynamicTopPositionIns', 'dynamicTopPositionPuc'].includes(field)) {
//         this[field] = 65;
//       }
//     }
//   }
// }

import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { ApiService } from 'src/app/Services/api.service';
import { CommonServices } from 'src/app/Services/common.service';
import { FileUploadService } from 'src/app/Services/file-upload.service';
import { StorageService } from 'src/app/Services/storage.service';
import { SweetAlert } from 'src/app/Services/sweetalet.service';
import { LoaderService } from 'src/app/Services/loader.service';

@Component({
  selector: 'app-create-vehicle',
  templateUrl: './create-vehicle.component.html',
  styleUrls: ['./create-vehicle.component.css'],
})
export class CreateVehicleComponent implements OnInit {

  public breadcrumbData = {
    "Information": "/organization/transport-manager/information",
    "Vendors": "/organization/transport-manager/information/vendor/view-vendor",
  };
  matFormSize = '13px';
  addVehicelForm: FormGroup;
  formSubmit: boolean = false;
  isShowSimno = false;
  isShowVendorName = false;

  isLocationMandatory: boolean = true;

  public vehicleLocation = {};
  public fieldOptions = {
    model: [
      { name: "Hatchback", value: "Hatchback", capacity: 3, max: 3 },
      { name: "Sedan", value: "Sedan", capacity: 4, max: 4 },
      { name: "SUV", value: "SUV", capacity: 7, max: 7 },
      { name: "Van", value: "Van", capacity: 15, max: 15 },
      { name: "Bus", value: "Bus", capacity: 60, max: 60 },
      { name: "Auto", value: "Auto", capacity: 3, max: 3 },
      { name: "Load Vehicle", value: "loadVehicle", capacity: 2, max: 100 }
    ],
  };

  VendorInfos: any;
  routerLinks: any;

  // rc
  imageData: File | undefined = undefined;
  filePreview: string | null = null;
  rcContentType: string | undefined = undefined;
  @ViewChild('rcfile') rcfile: ElementRef;

  // fc
  fcImage: File | undefined = undefined;
  fcPreview: string | undefined = undefined;
  fcContentType: string | null = null;
  @ViewChild('fcfile') fcfile: ElementRef;

  // puc
  pucImage: File | null = undefined;
  pucPreview: string | null = undefined;
  pucContentType: string | null = null;
  @ViewChild('pucfile') pucfile: ElementRef;

  // ins 
  insuranceImage: File | null = null;
  insPreview: string | null = null;
  insContentType: string | null = null;
  @ViewChild('insurancefile') insurancefile: ElementRef;
  dynamicTopPositionRc: number = 60;
  dynamicTopPositionFC: number = 60;
  dynamicTopPositionIns: number = 60;
  dynamicTopPositionPuc: number = 60;

  /* Branch field */
  public branchLists: any = [];
  public selectedBranch = [];
  @ViewChild('branchSearch') branchSearchTextBox: ElementRef;
  branchSearchChangeObserver: any;
  public enableBranchField: boolean = false;
  public branchSearchVal: any = '';

  /* Error object */
  public errorObject: any = {};

  //For status default select
  public statusSelected: any = '';
  public vehStatus: any = '';
  //display remarks
  public showRemarks = false;
  //vehicle capacity
  public vehCapacity: any = {};
  fuelType: any;
  imageUrl: any;
  minDate: Date;

  constructor(
    public fb: FormBuilder,
    public api: ApiService,
    public swal: SweetAlert,
    public storage: StorageService,
    public router: Router,
    public file: FileUploadService,
    public comService: CommonServices,
    public loader:LoaderService
  ) {

    this.VendorInfos = this.storage.get('vendorID_orgID');
    let vendorName = this.VendorInfos['vendorName'];
    if (vendorName) {
      vendorName = this.comService.strTruncate(vendorName, 13);
      this.breadcrumbData[vendorName] = "/organization/transport-manager/information/vendor/single-view-vendor/" + this.VendorInfos.vendorID;
    } else {
      this.breadcrumbData['Vendor'] = "/organization/transport-manager/information/vendor/single-view-vendor/" + this.VendorInfos.vendorID;
    }
    this.breadcrumbData['Vehicles'] = "/organization/transport-manager/information/vehicle/view-vehicle/" + this.VendorInfos.vendorID;
    this.breadcrumbData['Create'] = '';

    this.routerLinks = `/organization/transport-manager/information/vehicle/view-vehicle/${this.VendorInfos.vendorID}`;
  }

  ngOnInit(): void {
    this.getVehCapacity();
    this.getBranchList();
    this.addFormLoad();
    // const today = new Date().toISOString().split('T')[0];
    // console.log("today?",today)
    // document.getElementById('rcExpiryDate').setAttribute('min', today);
    // const currentDate = new Date();
    this.minDate = new Date();
  }

  addFormLoad() {
    this.addVehicelForm = new FormGroup({
      vehRegNo: new FormControl('', [Validators.required, Validators.pattern('[A-Z|a-z]{2}[0-9]{1,2}[A-Z|a-z]{0,2}[0-9]{4}')]),
      imei: new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(50), Validators.pattern('^[0-9|a-z|A-Z]*$')]),
      make: new FormControl(''), /* , [Validators.required]), */
      model: new FormControl('', [Validators.required]),
      capacity: new FormControl('', [Validators.required, Validators.min(1), Validators.max(100)]),
      vehicleType: new FormControl('', [Validators.required]),
      branch: new FormControl('', [Validators.required]),

      chassisNo: new FormControl(''), /* [Validators.required, Validators.minLength(17)]), */
      engineNo: new FormControl(''), /* [Validators.required, Validators.minLength(17)]), */
      vehRegDate: new FormControl('', [Validators.required]),
      routePermitNo: new FormControl(''),
      startDate: new FormControl(''), /* [Validators.required]), */
      rcNo: new FormControl(''), /* [Validators.required]), */
      rcfile: new FormControl(''), /* [Validators.required]), */
      vehicleInfo: new FormControl(''), /* [Validators.required]), */
      location: new FormControl('', [Validators.required]),
      boxType: new FormControl('', [Validators.required]),
      isActive: new FormControl('', [Validators.required]),
      // remarks:new FormControl('', [Validators.required]),
      roadTaxStatus: new FormControl(''), /* [Validators.required]), */
      fuelType: new FormControl('', [Validators.required]),
      rcStartDate: new FormControl('', [Validators.required]),
      rcExpiryDate: new FormControl('', [Validators.required]),
      pucExpiryDate: new FormControl('', [Validators.required]),
      fcExpiryDate: new FormControl('', [Validators.required]),
      insuranceExpiryDate: new FormControl('', [Validators.required]),
      fcfile: new FormControl(''),/* [Validators.required]), */
      insurancefile: new FormControl(''),/* [Validators.required]), */
      pucfile: new FormControl(''),/* [Validators.required]), */
    });
    // const rcStartDate = this.addVehicelForm.get('rcStartDate').value;
    // this.minExpiryDate = rcStartDate ? new Date(rcStartDate).toISOString().split('T')[0] : new Date().toISOString().split('T')[0];
  }

  _keyPress(event: any) {
    const pattern = /[0-9]/;
    const inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  getLocation(obj) {
    // console.log(obj);
    this.vehicleLocation = { ...obj };
  }

  patchVehicleCapacity(e) {
    this.vehCapacity.filter((option) => {
      if (option.value == e.value) {
        this.addVehicelForm.controls['capacity'].setValidators([Validators.required, Validators.min(1), Validators.max(option.max)])
        this.addVehicelForm.controls['capacity'].patchValue(option.capacity);
      }
    })
    if (this.formSubmit) this.validation();
  }
  patchFuelType(e) {
  }
  typeChange(e) {
  }

  onChangeBoxType(e) {
    // console.log(e.value);
    this.isShowVendorName = false;
    this.isShowSimno = false;
    if (e.value == 'others') {
      this.addVehicelForm.removeControl('simNo');
      this.addVehicelForm.addControl('vendorName', new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z0-9 ]+$')])); /* , [Validators.required])); */
      this.isShowVendorName = true;
    }
    if (e.value == 'G10 Gps Device') {
      this.addVehicelForm.removeControl('vendorName');
      this.addVehicelForm.addControl('simNo', new FormControl('', [Validators.required, Validators.minLength(10), Validators.maxLength(13)]));
      this.isShowSimno = true;
    }
    if (this.formSubmit) this.validation();
  }
  getVehCapacity() {
    this.api.transportManagerVehicleCapacity({}).then((res: any) => {
      if (res.status == 'success' && res.data.length > 0 && res.data[0].vehicleTypes.length > 0) {
        this.vehCapacity = res.data[0].vehicleTypes;
        this.fuelType = res.data[0].fuelType;
      }
    }).catch((err) => {
      console.log(err);
    });
  }
  getBranchList(name?) {
    this.enableBranchField = false;
    this.branchLists = [];
    const obj = {};
    if (name) obj['branchName'] = name;

    this.api.transportManagerBranchList(obj).then((res: any) => {
      if (res.status == 'success') {
        if (res.data && res.data.length > 0) {
          res.data.filter(item => {
            try {
              if (item.branchName && item.branchID) {
                let branchObj = {
                  name: item.branchName,
                  value: item.branchID,
                };
                let pushObj: boolean = true;
                this.selectedBranch.map((item) => { if (item.value == branchObj.value) { pushObj = false; } });
                if (pushObj) this.branchLists.push(branchObj);

              }
            } catch (err) {
              console.log('branch', err);
            }
          });
        }
      }
      setTimeout(() => { this.enableBranchField = true }, 200);
    }).catch((err) => {
      console.log(err);
    });
  }

  // search
  branchSearchChange(searchValue: string) {
    searchValue = searchValue.trim().replace(/[^a-zA-Z0-9-_&, ]/g, '');

    if (!this.branchSearchChangeObserver) {
      new Observable(observer => {
        this.branchSearchChangeObserver = observer;
      }).pipe(debounceTime(500)) // wait 300ms after the last event before emitting last event
        .pipe(distinctUntilChanged()) // only emit if value is different from previous value
        .subscribe((term: any) => {
          // your code here
          this.getBranchList(term);
        });
    }

    this.branchSearchChangeObserver.next(searchValue);
  }

  branchSelectionResult(value) {
    if (!Array.isArray(value)) value = [value];
    let result = [];
    let removedResult = [];
    for (let i = 0; i < value.length; i++) {
      let val = value[i];
      this.selectedBranch.map((item) => {
        if (item.value == val) {
          let valIndex = result.findIndex((e) => e.value == item.value);
          if (valIndex == -1) result.push(item);
        }
      })
      this.branchLists.map((veh) => {
        if (veh.value == val) {
          let valIndex = result.findIndex((e) => e.value == veh.value);
          if (valIndex == -1) result.push(veh);
        }
      })
    }
    this.selectedBranch.map((branch) => {
      if (!value.includes(branch.value)) {
        let pushObj: boolean = true;
        removedResult.map((e) => { if (e.value == branch.value) pushObj = false; });
        if (pushObj) removedResult.unshift(branch);
      }
    })
    this.enableBranchField = false;
    this.branchLists = [...removedResult, ...this.branchLists]
    this.enableBranchField = true;

    this.selectedBranch = [...result];
    if (this.branchSearchTextBox && this.branchSearchTextBox.nativeElement)
      this.branchSearchTextBox.nativeElement.value = '';
    this.clearDuplicates();
  }

  clearDuplicates() {
    let result = [];
    this.enableBranchField = false;
    this.branchLists.map((branchObj) => {

      let pushObj: boolean = true;
      this.selectedBranch.map((item) => { if (item.value == branchObj.value) pushObj = false; });
      if (pushObj) result.push(branchObj);

    });
    this.branchLists = [...result];
    this.enableBranchField = true;
  }

  clearBranchSearch(event) {
    this.branchSearchTextBox.nativeElement.value = '';
    this.getBranchList();
  }

  /* private getChangedProperties(): string[] {
    let changedProperties = [];
  
    Object.keys(this.addVehicelForm.controls).forEach((name) => {
      const currentControl = this.addVehicelForm.controls[name];
  
      if (currentControl.dirty) {
        changedProperties.push(name);
      }
    });
    
    return changedProperties;
  } */



  async handleUpload(event: Event, type: string) {
    const file = (event.target as HTMLInputElement).files?.[0];
    const maxFileSizeInMB = 1;
    const maxFileSize = maxFileSizeInMB * 1024 * 1024;
    const allowedImageTypes = ['image/jpeg', 'image/png', 'image/gif'];
    const allowedPdfType = 'application/pdf';

    if (!file) return;

    const fileType = file.type;
    const isImageOrPdf = allowedImageTypes.includes(fileType) || fileType === allowedPdfType;

    if (!isImageOrPdf) {
      this.handleInvalidFileType(type);
      return this.showErrorMessage('Invalid file type. Only images and PDFs are allowed.');
    }

    if (file.size > maxFileSize) {
      this.handleFileSizeExceeded(type);
      return this.showErrorMessage(`File size exceeds ${maxFileSizeInMB} MB`);
    }

    this.processFile(file, type, fileType, allowedImageTypes.includes(fileType) ? 'Image' : 'PDF');

    if (this.formSubmit) this.validation();
  }

  private processFile(file: File, type: string, fileType: string, contentType: string) {
    const fileReader = new FileReader();
    fileReader.onload = () => this.updateFormAndPreview(type, file, fileReader.result as string, contentType);
    fileReader.readAsDataURL(file);
  }

  private updateFormAndPreview(type: string, file: File, previewData: string, contentType: string) {
    switch (type) {
      case 'rcfile':
        this.imageData = file;
        this.rcContentType = contentType;
        this.filePreview = previewData;
        this.addVehicelForm.controls.rcfile.patchValue(file);
        break;
      case 'fcfile':
        this.fcImage = file;
        this.fcContentType = contentType;
        this.fcPreview = previewData;
        this.addVehicelForm.controls.fcfile.patchValue(file);
        break;
      case 'pucfile':
        this.pucImage = file;
        this.pucContentType = contentType;
        this.pucPreview = previewData;
        this.addVehicelForm.controls.pucfile.patchValue(file);
        break;
      case 'insurancefile':
        this.insuranceImage = file;
        this.insContentType = contentType;
        this.insPreview = previewData;
        this.addVehicelForm.controls.insurancefile.patchValue(file);
        break;
    }
  }

  private handleInvalidFileType(type: string) {
    this.resetFileFields(type);
  }

  private handleFileSizeExceeded(type: string) {
    this.resetFileFields(type);
  }

  private resetFileFields(type: string) {
    switch (type) {
      case 'rcfile':
        this.imageData = null;
        this.filePreview = null;
        this.rcContentType = null;
        this.addVehicelForm.controls.rcfile.reset();
        this.clearInputField(this.rcfile);
        break;
      case 'fcfile':
        this.fcImage = null;
        this.fcPreview = null;
        this.fcContentType = null;
        this.addVehicelForm.controls.fcfile.reset();
        this.clearInputField(this.fcfile);
        break;
      case 'pucfile':
        this.pucImage = null;
        this.pucPreview = null;
        this.pucContentType = null;
        this.addVehicelForm.controls.pucfile.reset();
        this.clearInputField(this.pucfile);
        break;
      case 'insurancefile':
        this.insuranceImage = null;
        this.insPreview = null;
        this.insContentType = null;
        this.addVehicelForm.controls.insurancefile.reset();
        this.clearInputField(this.insurancefile);
        break;
    }
  }

  private clearInputField(inputElement: ElementRef) {
    if (inputElement) inputElement.nativeElement.value = '';
  }

  private showErrorMessage(message: string) {
    this.swal.swalFunction('error', 'error', message, 5000);
  }


  reUpload(field: string) {
    const fileFieldMap = {
      'rcfile': this.rcfile,
      'fcfile': this.fcfile,
      'pucfile': this.pucfile,
      'insurancefile': this.insurancefile
    };

    const fileInput = fileFieldMap[field];
    if (fileInput) {
      fileInput.nativeElement.click();
    }
  }

  cancelImage(type: string) {
    if (type == 'rcfile') {
      this.addVehicelForm.controls.rcfile.patchValue('');
      this.imageData = undefined;
    } if (type == 'fcfile') {
      this.addVehicelForm.controls.fcfile.patchValue('');
      this.fcImage = undefined;
    } if (type == 'pucfile') {
      this.addVehicelForm.controls.pucfile.patchValue('');
      this.pucImage = undefined;
    } if (type == 'insurancefile') {
      this.addVehicelForm.controls.insurancefile.patchValue('');
      this.insuranceImage = undefined;
    }
  }

  // check Error in form field
  public checkError = (controlName: string, errorName: string) => {
    return this.addVehicelForm.controls[controlName].hasError(errorName);
  }

  statusChange(value: any) {
    this.vehStatus = true;
    this.showRemarks = false;
    if (this.vehStatus !== (value === 'true')) {
      this.showRemarks = true;
    }
    if (this.showRemarks) {
      this.addVehicelForm.addControl("remarks", new FormControl('', [Validators.required]));
    } else {
      this.addVehicelForm.removeControl("remarks");
    }
  }
  validation() {
    this.errorObject = {};
    let fields = Object.keys(this.addVehicelForm.controls);
    fields.map((field) => {
      if (this.checkError(field, 'required')) {
        this.errorObject[field] = field.charAt(0).toUpperCase() + field.slice(1).toLowerCase() + ' is required';
        if (field == 'vehRegNo') this.errorObject[field] = 'Registration No is required';
        else if (field == 'imei') this.errorObject[field] = 'IMEI is required';
        else if (field == 'vehicleType') this.errorObject[field] = 'Vehicle Type is required';
        else if (field == 'chassisNo') this.errorObject[field] = 'Chassis No is required';
        else if (field == 'engineNo') this.errorObject[field] = 'Engine No is required';
        else if (field == 'vehRegDate') this.errorObject[field] = 'Vehicle Registration Date is required';
        else if (field == 'fcExpiryDate') this.errorObject[field] = 'FC expiry date  is required';
        else if (field == 'pucExpiryDate') this.errorObject[field] = 'PUC expiry date is required';
        else if (field == 'routePermitCost') this.errorObject[field] = 'Route Permit Cost is required';
        else if (field == 'startDate') this.errorObject[field] = 'Start Date is required';
        else if (field == 'insuranceExpiryDate') this.errorObject[field] = 'Insurance expiry date is required';
        else if (field == 'rcNo') this.errorObject[field] = 'RC Book No is required';
        else if (field == 'rcStartDate') this.errorObject[field] = 'RC Start date is required';
        else if (field == 'rcExpiryDate') this.errorObject[field] = 'RC expiry date is required';
        else if (field == 'location') this.errorObject[field] = 'Work Location is required';
        else if (field == 'vehicleInfo') this.errorObject[field] = 'Vehicle Info is required';
        else if (field == 'boxType') this.errorObject[field] = 'Box type is required';
        else if (field == 'isActive') this.errorObject[field] = 'Status is required';
        else if (field == 'remarks') this.errorObject[field] = 'Remarks is required';
        else if (field == 'vendorName') this.errorObject[field] = 'Vendor Name is required';
        else if (field == 'simNo') this.errorObject[field] = 'SIM No is required';
        else if (field == 'roadTaxStatus') this.errorObject[field] = 'Road Tax Paid is required';
        else if (field == 'rcfile') this.errorObject[field] = 'RC File is required';
        else if (field == 'fuelType') this.errorObject[field] = 'Fuel type is required';
        //else if (field == 'vehiclere')
      }
      else if (field == 'vehRegNo') {
        if (this.checkError(field, 'pattern')) this.errorObject[field] = 'Registration No is Incorrect';
      } else if (field == 'imei' || field == 'chassisNo' || field == 'engineNo' || field == 'routePermitCost') {
        if (this.checkError(field, 'minlength')) {
          if (field == 'imei') this.errorObject[field] = "IMEI should be above 3 characters";
          else if (field == 'chassisNo') this.errorObject[field] = "Chassis No should be more than 17 characters";
          else if (field == 'engineNo') this.errorObject[field] = "Engine No should be more than 17 characters";
          else if (field == 'routePermitCost') this.errorObject[field] = "Route Permit Cost should be minimum than 4 digits";
        } else if (this.checkError(field, 'maxlength')) {
          if (field == 'imei') this.errorObject[field] = "IMEI should be less than 50 characters";
          else if (field == 'routePermitCost') this.errorObject[field] = "Route Permit Cost should be more than 7 digits";
        }
        else if (this.checkError(field, 'pattern')) {
          if (field == 'imei') this.errorObject[field] = "IMEI should be valid";
        }
      } else if (field == 'capacity') {
        if (this.checkError(field, 'min')) this.errorObject[field] = "Minimum capacity is required";
        else if (this.checkError(field, 'max')) this.errorObject[field] = "Maximum capacity is reached";
      }
      else if (field == 'rcStartDate' || field == 'rcExpiryDate' || field == 'expiryDate' || field == 'startDate') {
        if (this.checkError(field, 'matDatepickerMin')) {
          if (field == 'startDate') this.errorObject[field] = 'Start Date is Invalid';
          else if (field == 'expiryDate') this.errorObject[field] = 'Expiry Date is Invalid';
          else if (field == 'rcStartDate') this.errorObject[field] = 'RC Start Date is Invalid';
          else if (field == 'rcExpiryDate') this.errorObject[field] = 'RC Expiry Date is Invalid';
        }
      }
    })
  }

  onSubmit() {
    this.formSubmit = true;
    this.validation();
    console.log(this.addVehicelForm.value);
    //console.log(this.getChangedProperties())
    if (!this.addVehicelForm.valid) {
      return;
    }

    const obj = {
      orgID: this.storage.get('userInfo').orgID,
      vendorID: this.VendorInfos.vendorID,
    };
    //obj.rcfile = this.imageData; 

    let keys = Object.keys(this.addVehicelForm.value);
    if (keys.length > 0) {
      for (let k = 0; k < keys.length; k++) {
        let key = keys[k];
        if (this.addVehicelForm.value[key] != '' &&
          this.addVehicelForm.value[key] != [] &&
          this.addVehicelForm.value[key] != {}) {
          obj[key] = this.addVehicelForm.value[key];
        }
      }
    }

    if (Object.keys(this.vehicleLocation).length > 0) obj['location'] = { ...this.vehicleLocation };
    if (obj['roadTaxStatus']) obj['roadTaxStatus'] = obj['roadTaxStatus'] == 'true' ? true : false;
    if (obj['vehRegNo']) obj['vehRegNo'] = obj['vehRegNo'].toUpperCase();
    if (obj['fcExpiryDate']) obj['fcExpiryDate'] = new Date(obj['fcExpiryDate']).getTime();
    if (obj['rcExpiryDate']) obj['rcExpiryDate'] = new Date(obj['rcExpiryDate']).getTime();
    if (obj['insuranceExpiryDate']) obj['insuranceExpiryDate'] = new Date(obj['insuranceExpiryDate']).getTime();
    if (obj['pucExpiryDate']) obj['pucExpiryDate'] = new Date(obj['pucExpiryDate']).getTime();
    if (obj['rcExpiryDate']) obj['rcExpiryDate'] = new Date(obj['rcExpiryDate']).getTime();
    if (obj['rcStartDate']) obj['rcStartDate'] = new Date(obj['rcStartDate']).getTime();
    if (obj['vehRegDate']) obj['vehRegDate'] = new Date(obj['vehRegDate']).getTime();
    if (obj['simNo']) obj['simNo'] = parseInt(obj['simNo']);
    //if (obj['vendorName']) obj['vendorName'] = parseInt(obj['vendorName']);
    if (obj['isActive']) obj['isActive'] = (obj['isActive'] === 'true');
    if (obj['capacity']) obj['capacity'] = parseInt(obj['capacity']);

    if (this.imageData) {
      obj['rcFiles'] = this.imageData;
      obj['rcContentType'] = this.rcContentType;
    }
    if (this.fcImage) {
      obj['fcFiles'] = this.fcImage;
      obj['fcContentType'] = this.fcContentType;
    };
    if (this.insuranceImage) {
      obj['insFiles'] = this.insuranceImage;
      obj['insContentType'] = this.insContentType;
    }
    if (this.pucImage) {
      obj['pucFiles'] = this.pucImage;
      obj['pucContentType'] = this.pucContentType;
    };
    delete obj['pucfile'];
    delete obj['fcfile'];
    delete obj['rcfile'];
    delete obj['insurancefile'];



    let url = 'organization/vehicle/createVehicle';
    this.api.transportManagerFormDataCreate(obj, url, (res: any) => {
      if (res['responseJSON']['status'] == 'success') {
        this.imageData = undefined;
        this.fcImage = undefined;
        this.pucImage = undefined;
        this.insuranceImage = undefined;
        this.swal.swalFunction(res['responseJSON'].status, res['responseJSON'].status, res['responseJSON'].message, 2000);
        this.router.navigate([this.routerLinks]);
      }
      if (res['responseJSON'].status == 'failure') {
        this.loader.hide();
        this.swal.swalFunction('error', res['responseJSON'].status, res['responseJSON'].message, 3000);
      }
    })
  }
  previewImage(imageUrl) {
    // this.imageUrl = image;
    if (imageUrl.startsWith('data:image')) {
      const newWindow = window.open();
      if (newWindow) {
        newWindow.document.write(`<img src="${imageUrl}" style="width:100%;">`);
        newWindow.document.title = "Image Preview";
      }
    } else {
      window.open(imageUrl, '_blank');
    }
  }
  openPdf(pdfUrl: string) {
    if (pdfUrl.startsWith('data:application/pdf;base64,')) {
      const newWindow = window.open();
      if (newWindow) {
        newWindow.document.write(`
          <html>
            <head>
              <title>PDF Preview</title>
            </head>
            <body style="margin: 0; padding: 0; overflow: hidden;">
              <embed src="${pdfUrl}" type="application/pdf" width="100%" height="100%" />
            </body>
          </html>
        `);
      }
    } else {
      // Handle URL-based PDF
      window.open(pdfUrl, '_blank');
    }
  }
  check() {
    console.log(this.addVehicelForm.value.rcExpiryDate)
  }
  truncateFilename(filename: string | undefined): string {
    if (!filename) return '';
    if (filename.length <= 20) return filename;
    return filename.substr(0, 10) + '...' + filename.substr(filename.length - 7);
  }

  onImageLoad(event: Event, field: string) {
    const imgElement = event.target as HTMLImageElement;

    const imageWidth = imgElement.naturalWidth;
    const imageHeight = imgElement.naturalHeight;

    if (imageWidth >= 1080 && imageHeight <= 2376) {
      if (['dynamicTopPositionRc', 'dynamicTopPositionFC', 'dynamicTopPositionIns', 'dynamicTopPositionPuc'].includes(field)) {
        this[field] = 140
      }
    }
    else if ((imageWidth >= 400 && imageWidth <= 2532) && (imageHeight >= 1000 && imageHeight <= 2780)) {
      if (['dynamicTopPositionRc', 'dynamicTopPositionFC', 'dynamicTopPositionIns', 'dynamicTopPositionPuc'].includes(field)) {
        this[field] = 150;
      }
    }
    else {
      if (['dynamicTopPositionRc', 'dynamicTopPositionFC', 'dynamicTopPositionIns', 'dynamicTopPositionPuc'].includes(field)) {
        this[field] = 65;
      }
    }
  }
}

